import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { Button, Container } from "react-bootstrap";

const GeneralSettings = () => {
  const [maxWithdrawal, setMaxWithdrawal] = useState("");
  const [minWithdrawal, setMinWithdrawal] = useState("");
  const [tds, setTds] = useState("");
  const [serviceTax, setServiceTax] = useState("");
  const [advanceData, setAdvanceData] = useState(null);

  const fetchData = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get-advance-info");
      const settings = data?.data?.withdrawal?.main_wallet || {};
      setAdvanceData(data?.data);
      setMaxWithdrawal(settings?.max_withdrawal || "");
      setMinWithdrawal(settings?.min_withdrawal || "");
      setTds(settings?.TDS || "");
      setServiceTax(settings?.service_tax || "");
    } catch (error) {
      console.error(error?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "maxWithdrawal") setMaxWithdrawal(value);
    else if (name === "minWithdrawal") setMinWithdrawal(value);
    else if (name === "tds") setTds(value);
    else if (name === "serviceTax") setServiceTax(value);
  };

  const handleUpdate = async () => {
    try {
      const body = {
        walletType: "main_wallet",
        maxWithdrawal: Number(maxWithdrawal),
        minWithdrawal: Number(minWithdrawal),
        tds: Number(tds),
        service_tax: Number(serviceTax),
      };
  
      console.log("-----", body);
  
      const { data, error } = await apiCall("POST", "/update-withdrawal-limits", body);
  
      if (data) {
        toast.success(data.message || "Withdrawal updated successfully!");
        fetchData();
      } else {
        toast.error(error?.message || "An error occurred!");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };


  return (
    <Container>
      <div className="bonanza-settings">
        <div className="input-row1">
          <h2>Withdrawal Settings</h2>

          <div className="input-group1">
            <label>Maximum Withdrawal:</label>
            <input
              type="number"
              name="maxWithdrawal"
              placeholder="Enter Max Withdrawal"
              value={maxWithdrawal}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group1">
            <label>Minimum Withdrawal:</label>
            <input
              type="number"
              name="minWithdrawal"
              placeholder="Enter Min Withdrawal"
              value={minWithdrawal}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group1">
            <label>Utility Income:</label>
            <input
              type="number"
              name="tds"
              placeholder="Enter TDS"
              value={tds}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group1">
            <label>Admin Charges:</label>
            <input
              type="number"
              name="serviceTax"
              placeholder="Enter Service Tax"
              value={serviceTax}
              onChange={handleChange}
              required
            />
          </div>

          <div className="button-container">
            <Button variant="primary" onClick={handleUpdate}>
              Update
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default GeneralSettings;
